module.exports = __webpack_public_path__ + "img/logo-malaysian-bar-council@3x.844648d6.png";